import { SharedModule } from '../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentCatalogDuplicatesComponent } from './components/modals/content-catalog-duplicates/content-catalog-duplicates.component';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [ContentCatalogDuplicatesComponent],
  imports: [CommonModule, SharedModule, NgbAccordionModule],
  providers: [],
  exports: [ContentCatalogDuplicatesComponent],
})
export class ContentCatalogSharedModule {}
